import {
	createFileRoute,
	Outlet,
	Link,
	useNavigate,
} from "@tanstack/react-router";
import {
	Card,
	CardHeader,
	CardTitle,
	CardDescription,
	CardContent,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PencilLine, ArrowLeft } from "lucide-react";

// UI
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

import { Separator } from "@/components/ui/separator";

// Icons

// Magic Value
import siteConfig from "@/config/site";

export const Route = createFileRoute(
	"/_layout-private/report/finance/bank/_layout",
)({
	component: FinanceDetail,
});

function FinanceDetail() {
	const navigate = useNavigate();

	const sidebarMenus = siteConfig.getFinanceSideBarMenusbank();

	return (
		<>
			<Breadcrumb>
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink>
							<Link to="/report/finance">ລາຍງານການເງິນຂອງບໍລິສັດ</Link>
						</BreadcrumbLink>
					</BreadcrumbItem>
					<BreadcrumbSeparator />

					<BreadcrumbItem>
						<BreadcrumbPage>ສ້າງລາຍງານການເງິນຂອງທະນາຄານ</BreadcrumbPage>
					</BreadcrumbItem>
				</BreadcrumbList>
			</Breadcrumb>

			{/* <div className="flex flex-row w-full h-full gap-2 py-[24px] overflow-y-auto">
				<nav className="w-[20%]">
					<ul>
						{sidebarMenus.map((menu) => (
							<li key={menu.name}>
								<Link
									to={menu.href}
									className="px-4 py-2 rounded-md  flex items-center [&.active]:font-bold [&.active]:bg-muted [&.active]:text-primary  text-[14px] "
								>
									{menu.name}
								</Link>
							</li>
						))}
					</ul>
				</nav>

				<div className="w-[80%]">
					<Outlet />
				</div>
			</div> */}

			<div className="relative flex flex-row h-screen p-4 ">
				<aside className="w-[20%]  border-r sticky top-0  	">
					<nav className="mt-[40px] space-y-4 ">
						<ul>
							{sidebarMenus.map((menu) => (
								<li key={menu.name}>
									<Link
										to={menu.href}
										className="px-4 py-2 rounded-md  flex items-center [&.active]:font-bold [&.active]:bg-muted [&.active]:text-primary  text-[14px] "
									>
										{menu.name}
									</Link>
								</li>
							))}
						</ul>
					</nav>
				</aside>
				<div className=" w-[80%] h-[80%] overflow-y-auto scrollbar-hide ">
					<main className="py-[24px]  ">
						<Outlet />
					</main>
				</div>
			</div>
		</>
	);
}
